module.exports = __webpack_public_path__ + "static/media/tailwind.82ce64d1.png";